import {
  ElIcon,
  ElPagination,
  ElInput,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElAffix,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
} from "element-plus";
import config from "../config";
import innerAPP from "./../innerAPP";
import App from "./App";
const vm = innerAPP(App, config.schoolId);
vm.use(ElIcon)
  .use(ElPagination)
  .use(ElInput)
  .use(ElMenu)
  .use(ElSubMenu)
  .use(ElMenuItem)
  .use(ElAffix)
  .use(ElDropdown)
  .use(ElDropdownMenu)
  .use(ElDropdownItem);
vm.mount("#app");
